import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetReportIssue, reportIssue } from "./report-issue";

const initialState: ProcessingState = { processing: "idle" };

export const reportIssueReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(reportIssue.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(reportIssue.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(reportIssue.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetReportIssue, () => {
    return initialState;
  });
});
